import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Movie from '../components/movie/Movie';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Marquee from "react-fast-marquee";




const baseUrl ="https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=6ca13f43a1a801b9dda8e5bf874d1e3e&page=1";
const searchApi = "https://api.themoviedb.org/3/search/movie?&api_key=6ca13f43a1a801b9dda8e5bf874d1e3e&query=";

export default function HomeScreen({match}) {

  window.scrollTo(0, 0);

   // Direct link code start

   const links = [
    'https://www.profitableratecpm.com/decf6q7di?key=a4f21406e35277c2c60a8e74d5b665e7',
    'https://www.cpmrevenuegate.com/siinmp29?key=d4ec47048b3bf214fadb7091e2d524d1',
    'https://www.profitableratecpm.com/decf6q7di?key=a4f21406e35277c2c60a8e74d5b665e7',
    'https://www.effectiveratecpm.com/ebrte7dc?key=5acd73bdcd9a40d2d2a6e6376b7c902e',
    'https://www.profitableratecpm.com/decf6q7di?key=a4f21406e35277c2c60a8e74d5b665e7',
  ];
  
  useEffect(() => {
    // Function to handle clicks and open random links
    const handleClick = () => {
      const lastClickTime = localStorage.getItem('lastClickTime');
      const now = new Date().getTime();

      // If there's no last click time or if 10 minutes have passed, open a new link
      if (!lastClickTime || now - lastClickTime >= 10000) {
        // Get a random link from the array
        const randomLink = links[Math.floor(Math.random() * links.length)];

        // Open the link in a new tab
        window.open(randomLink, '_blank');

        // Update the last click time in localStorage
        localStorage.setItem('lastClickTime', now);
      }
    };

    // Add click event listener
    window.addEventListener('click', handleClick);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);
    

  // Direct link code end

  const keyword = match.params.searchTerm;
  //console.log(keyword);  
  const [movies , setMovies] = useState([]);

  const [searchTerm , setSearchTerm] = useState('');


  useEffect(() => {
    const homeReloaded = localStorage.getItem('homeReloaded');
    if (!homeReloaded) {
      localStorage.setItem('homeReloaded', 'true');
      window.location.reload();
    } else {
      // Clear the flag to allow for reloading on future visits
      localStorage.removeItem('homeReloaded');
    }
  }, []);




// Ads start


// const bannerRef = useRef(null); // Initialize ref

//   const atOptions = {
//     key: 'f7f99d04d4ff24043129015379ac1363', // Your actual key here
//     format: 'iframe',
//     height: 90,
//     width: 728,
//     params: {},
//   };

//   useEffect(() => {
//     // Check if the window width is greater than 768px
//     if (window.innerWidth > 768 && bannerRef.current && !bannerRef.current.firstChild) {
//       const conf = document.createElement('script');
//       const script = document.createElement('script');

//       // Set the ad options
//       conf.innerHTML = `atOptions = ${JSON.stringify(atOptions)}`;
//       script.type = 'text/javascript';
//       script.src = `//www.topcreativeformat.com/${atOptions.key}/invoke.js`;

//       // Append the scripts to the banner div
//       bannerRef.current.appendChild(conf);
//       bannerRef.current.appendChild(script);
//     }
//   }, []); // Run once on mount



// const bannerRef = useRef(null); // Reference for the banner ad container
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // State to track screen size

//   const checkScreenSize = () => {
//     setIsMobile(window.innerWidth < 768);
//   };

//   useEffect(() => {
//     // Add event listener for screen resize
//     window.addEventListener('resize', checkScreenSize);

//     // Load the appropriate banner ad based on screen size
//     loadBannerAd();

//     // Set interval to switch ads every 1 seconds
//     const interval = setInterval(loadBannerAd, 120000); // Change ad every 10 seconds

//     // Clean up the event listener and interval
//     return () => {
//       window.removeEventListener('resize', checkScreenSize);
//       clearInterval(interval);
//     };
//   }, []);

//   const loadBannerAd = () => {
//     if (bannerRef.current) {
//       // Clear the previous ad if it exists
//       bannerRef.current.innerHTML = '';

//       // Load the appropriate ad based on screen size
//       const script = document.createElement('script');
//       const atOptions = isMobile
//         ? {
//             key: '648a5273de281afba700b004292c0e61',
//             format: 'iframe',
//             height: 50,
//             width: 320,
//             params: {},
//           }
//         : {
//             key: 'f7f99d04d4ff24043129015379ac1363',
//             format: 'iframe',
//             height: 90,
//             width: 728,
//             params: {},
//           };

//       // Set the ad options in the script
//       script.type = 'text/javascript';
//       script.innerHTML = `atOptions = ${JSON.stringify(atOptions)};`;
      
//       // Set the script source based on screen size
//       const src = isMobile
//         ? '//www.topcreativeformat.com/648a5273de281afba700b004292c0e61/invoke.js'
//         : '//www.topcreativeformat.com/f7f99d04d4ff24043129015379ac1363/invoke.js';

//       const adScript = document.createElement('script');
//       adScript.src = src;

//       // Append the script to the banner container
//       bannerRef.current.appendChild(script);
//       bannerRef.current.appendChild(adScript);
//     }
//   };




  const adContainerRef = useRef(null); // Reference for the ad container

  useEffect(() => {
    // Create a script element for the Adsterra banner
    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    script.src = '//pl24583017.cpmrevenuegate.com/e53d6b1dfa2204cc62aba0669ef16a4f/invoke.js';

    // Append the script to the document body
    document.body.appendChild(script);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);









// Ads end

  // useEffect(
  //   () => {
  //     fetch("http://localhost:5000/api/movies/")
  //     .then(res => res.json())
  //     .then((data) =>{
  //     //  console.log(data);
  //     })
  //   }
  // );

  useEffect(
    () => {
fetch(baseUrl)
.then(res => res.json())
.then((data) => {
   // console.log(data);
  setMovies(data.results);

});
    },[]
  ); 




  

const handleSubmit = (e) => {

  e.preventDefault();

if(searchTerm){

  fetch(searchApi + searchTerm)
.then(res => res.json())
.then((data) => {
  setMovies(data.results);
}
)

.catch(err => console.log('error', err));;

setSearchTerm('');
}


  

};


useEffect(() => {

  if(keyword){

    fetch(searchApi + keyword)
    .then(res => res.json())
    .then((data) => {
     setMovies(data.results);
    })
 
    .catch(err => console.log('error', err));
 
    
 }


},[keyword]);








const handleOnChange = (e) => {

  setSearchTerm(e.target.value);
}


// A ADS banner
// const adHTML = `
// <div id="frame" style="width:300px; height:auto;">
//   <iframe data-aa='2357019' src='//ad.a-ads.com/2357019?size=300x250' style='width:300px; height:250px; border:0px; padding:0; overflow:hidden; background-color: transparent;'></iframe>
//   <a style="display: block; text-align: right; font-size: 12px;" id="preview-link" href="https://aads.com/campaigns/new/?source_id=2357019&source_type=ad_unit&partner=2357019">Advertise here</a>
// </div>
// `;


const [fontSize, setFontSize] = useState("64px");

useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth < 640) {
      setFontSize("32px");
    } else {
      setFontSize("64px");
    }
  };

  window.addEventListener("resize", handleResize);

  // Set initial font size based on screen width
  handleResize();

  return () => {
    window.removeEventListener("resize", handleResize);
  };
}, []);

  return (
    <> 


<header >
<Link to="/">
<img src={require('../assets/movieloverbdlogo.png')} alt="movieloversbd logo" width="178" height="50" /> 
</Link>

  <form onSubmit={handleSubmit} >

  <input type="text" 
          className="search" 
          placeholder="Search..." 
          value={searchTerm}
          onChange={handleOnChange}
  />

  </form>
       
      </header>
       {/* Banner ad container for both mobile and desktop */}
       {/* <div
        ref={bannerRef}
        style={{ width: isMobile ? '320px' : '728px', height: isMobile ? '50px' : '90px' , margin: 'auto', marginBottom:"5px", marginTop:"5px"}}
      /> */}

      <div className="my-1"
      
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',}}>

        

        {/* <div
          dangerouslySetInnerHTML={{ __html: adHTML }}
        /> */}
      
      
      
      </div>

      <Marquee style={{fontSize: fontSize, color:"#f75123", fontWeight:"900", textTransform: "uppercase", border:"2.5px solid black", borderLeft:"none", borderRight:"none", marginBottom:"3px"}} pauseOnHover={true} speed={60}>
      🎬 Now Streaming! Watch the Latest Movies Live, Anytime, Anywhere! Share the Fun – Invite Friends and Enjoy Movies Together! 🎥✨
      </Marquee>
          
      <h1 style={{ textAlign: 'center' }}>Welcome to MOVIELOVERSBD | মুভি লাভারস  বিডি</h1>

      <h2 style={{ textAlign: 'center' }}>Millions of Movies🎥, you can download and stream from here. <br/>
      Search by movie name | মুভির নাম দিয়ে সার্চ করুন
      </h2>

      

     <div className="movie-container">
      
  
      {
        movies.map( (movie) => <Movie key={movie.id} mov={movie}></Movie>
        )
      }
  

        
      </div>

      <div
      id="container-e53d6b1dfa2204cc62aba0669ef16a4f"
      ref={adContainerRef}
      style={{ width: '100%', height: 'auto' }} // Adjust styles as needed
    />


     <Footer />
    </>
  )
}
